import { Layout, BlockingTimes as BlockingTimesComponent } from "components"
export const BlockingTimes = () => {
 return (
  <Layout>
   <BlockingTimesComponent />
  </Layout>
 )
}
